export default "__VITE_PUBLIC_ASSET__84bd17b6__"